"use strict";

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.promise");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.readBlobAsArrayBuffer = readBlobAsArrayBuffer;
exports.readBlobAsDataUrl = readBlobAsDataUrl;
exports.loadImage = loadImage;
exports.canvasToBlob = canvasToBlob;

function readBlobAs(blob, readFunction) {
  return new Promise(function (resolve, reject) {
    var reader = new FileReader();

    reader.onload = function (event) {
      return resolve(event.target.result);
    };

    readFunction.call(reader, blob);
  });
}

function readBlobAsArrayBuffer(blob) {
  return readBlobAs(blob, FileReader.prototype.readAsArrayBuffer);
}

function readBlobAsDataUrl(blob) {
  return readBlobAs(blob, FileReader.prototype.readAsDataURL);
}

function loadImage(url) {
  return new Promise(function (resolve, reject) {
    var img = new Image();

    img.onload = function (event) {
      return resolve(img);
    };

    img.onerror = function (error) {
      return reject(error);
    };

    img.src = url;
  });
}

function canvasToBlob(canvas, mimeType, quality) {
  return new Promise(function (resolve, reject) {
    canvas.toBlob(resolve, mimeType, quality);
  });
}